/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Ticket } from '@touchplan/common';
import { TicketType } from '@touchplan/common';

export class TicketUtils {
	public static getTicketType(ticket: Ticket): TicketType {
		switch (ticket.view.type) {
			case 'constraint':
				return TicketType.Constraint;
			case 'milestone':
				return TicketType.Milestone;
			case 'task':
				return TicketType.Task;
			default:
				return TicketType.Task;
		}
	}
}
